import axios from 'axios';

import { createApiError } from '@/api/utils/error';
import { PersonOrCompany } from '@/types/person-or-company';

export const getFnsOptions = async (inn: string) => {
	try {
		const { data } = await axios.get<{ suggestions: any[] }>(
			`${process.env.HOST}/api_v1/fns?search=${inn}`,
		);

		if (!data || !Array.isArray(data?.suggestions) || !data.suggestions.length) {
			throw new Error(`API ДаДата: не удалось получить данные по ИНН (${inn})`);
		}

		return data.suggestions
			.filter((el) => el?.['data']?.['state']?.['status'] === 'ACTIVE')
			.map((el) => {
				if (el['data']?.['type'] === 'LEGAL') {
					return {
						fullName: el?.['data']?.['name']?.['full_with_opf'],
						shortName: el?.['data']?.['name']?.['short_with_opf'],
						inn: el?.['data']?.['inn'],
						kpp: el?.['data']?.['kpp'],
						orgn: el?.['data']?.['ogrn'],
						address: el?.['data']?.['address']?.['value'],
						position: el?.['data']?.['management']?.['post'],
						fullNameHead: el?.['data']?.['management']?.['name'],
						index: el?.['data']?.['address']?.['data']?.['postal_code'],
					};
				} else if (el['data']?.['type'] === 'INDIVIDUAL') {
					return {
						fullName: el?.['data']?.['name']?.['full_with_opf'],
						inn: el?.['data']?.['inn'],
						orgn: el?.['data']?.['ogrn'],
						address: el?.['data']?.['address']?.['value'],
						index: el?.['data']?.['address']?.['data']?.['postal_code'],
					};
				}
			}) as PersonOrCompany[];
	} catch (error) {
		throw createApiError(error, 'Ошибка получения данных ДаДата');
	}
};
